import React from 'react'
import Button from '@everlane/button'
import { Arrow } from '@everlane/icon'
import RouterLink from 'base/components/router_link'
import Event from 'base/event'
import classNames from 'classnames'
import ImageHelper from 'base/lib/image_helper'
import setEvents from './menu_helpers'

const defaultEventProperties = {
  type: 'text',
  placement: 'top',
}

function DropdownMenuV2({ category, visible }) {
  return (
    <div className="app-subheader__dropdown" hidden={!visible}>
      {category.sections && category.sections.length > 0 && (
        <div className="app-subheader__dropdown-sections">
          {category.sections?.map((section, index) => (
            <div className="app-subheader__dropdown-section" key={`${section.title}-${index}`}>
              {section.title && (
                <h3 className="app-subheader__dropdown-section-title">{section.title}</h3>
              )}
              <ul>
                {section.links?.map((link, index) => (
                  <li
                    key={`${link.permalink}-${index}`}
                    className="app-subheader__dropdown-section-link"
                  >
                    <RouterLink
                      href={link.permalink}
                      className="app-subheader__dropdown-section-link-text"
                      onClick={() =>
                        setEvents({
                          ...defaultEventProperties,
                          eventName: Event.Navigation.LINK_CLICK,
                          name: link.text,
                          url: link.permalink,
                        })
                      }
                    >
                      {link.text}
                    </RouterLink>
                  </li>
                ))}
                <li className="app-subheader__dropdown-section-link" key="shop-all-dropdown">
                  {index === 0 && category.permalink && (
                    <RouterLink
                      className="app-subheader__dropdown-section-link-text"
                      href={category.permalink}
                      onClick={() => {
                        setEvents({
                          ...defaultEventProperties,
                          eventName: Event.Navigation.LINK_CLICK,
                          name: `Shop All ${category.text}`,
                          url: category.permalink,
                        })
                      }}
                    >
                      {`Shop All ${category.text}`}
                    </RouterLink>
                  )}
                </li>
              </ul>
            </div>
          ))}
        </div>
      )}

      {category.images?.length > 0 && (
        <div className="app-subheader__dropdown-sections">
          {category.images.map((image, index) => (
            <div
              className="app-subheader__dropdown-section app-subheader__dropdown-section--image"
              key={`${image.image}-${index}`}
            >
              <RouterLink
                href={image.url}
                onClick={() => {
                  setEvents({
                    ...defaultEventProperties,
                    eventName: Event.Navigation.LINK_CLICK,
                    name: image.buttonText,
                    url: image.url,
                    type: 'image',
                  })
                }}
                className={classNames('app-subheader__dropdown-image-link', {
                  'app-subheader__dropdown-image-link--product-tile': image.productTile,
                })}
              >
                {image.image && (
                  <img
                    loading="eager"
                    className="app-subheader__dropdown-image"
                    src={ImageHelper.imageUrl(image.image, {
                      size: 320,
                    })}
                  />
                )}
                {image.buttonText && !image.productTile && (
                  <Button
                    type="button"
                    onClick={() => null}
                    variant="icon"
                    className="app-subheader__dropdown-image-button"
                  >
                    <p className="app-subheader__dropdown-image-button-text">
                      {image.buttonText}
                      <Arrow className="app-subheader__dropdown-image-button-arrow" />
                    </p>
                  </Button>
                )}

                {image.buttonText && image.productTile && (
                  <p className="app-subheader__dropdown-image-tile-text">{image.buttonText}</p>
                )}
              </RouterLink>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default DropdownMenuV2
